<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import RangeSlider from 'svelte-range-slider-pips';

  import { Icon } from '@shared/ui/icon';
  import { cn } from '@shared/utils';

  export let min = 0;
  export let max = 100;
  export let values;
  export let vertical = false;
  export let size: 'sm' | 'md' | 'lg' = 'md';

  const dispatch = createEventDispatcher<{ zoomIn: void; zoomOut: void }>();
</script>

<div
  class="
      {cn(
    'viewer-range-slider text-default-900 bg-default-70/70 dark:bg-dark-500/60 relative flex items-center justify-between gap-4 rounded-full text-center drop-shadow backdrop-blur-2xl',
    {
      'flex-col': vertical,
      'flex-row-reverse': !vertical,
      'w-11': vertical,
      'h-11': !vertical,
      'py-3': vertical,
      'px-3': !vertical,
      'w-10': size === 'sm' && vertical,
      'h-10': size === 'sm' && !vertical,
      'h-full': vertical,
      'w-full': !vertical,
    },
  )}
    "
>
  <button
    class="text-default-600 hover:text-default-900 pointer-events-auto -m-3 p-3 dark:text-white/85 dark:hover:text-white/100"
    on:click="{() => dispatch('zoomIn')}"
  >
    <Icon name="plus" width="{22}" height="{22}" />
  </button>
  <div class="text-xxs pointer-events-auto flex h-full w-full items-center justify-center">
    <RangeSlider
      step="{1}"
      {min}
      {max}
      {values}
      on:stop
      springValues="{{ stiffness: 1, damping: 1 }}"
      {vertical}
      range="max"
    />
  </div>
  <button
    class="text-default-600 hover:text-default-900 pointer-events-auto -m-3 p-3 dark:text-white/85 dark:hover:text-white/100"
    on:click="{() => dispatch('zoomOut')}"
  >
    <Icon name="minus" width="{22}" height="{22}" />
  </button>
</div>

<style>
  .viewer-range-slider :global(.rangeSlider) {
    font-size: 10px;
    line-height: 12px;
    --range-slider: rgba(204, 204, 204, 1);
    --range-handle-inactive: hsla(0, 0%, 96%, 1);
    --range-handle: hsla(230, 94%, 82%, 1);
    --range-handle-focus: #ffffff;
    --range-handle-border: rgba(204, 204, 204, 1);
    --range-range: rgba(204, 204, 204, 1);
    --range-range-inactive: rgba(204, 204, 204, 1);

    --range-float-inactive: hsla(0, 0%, 96%, 1);
    --range-float: hsla(230, 94%, 82%, 1);
    --range-float-text: #000000;

    --range-pip: hsla(0, 0%, 67%, 1);
    --range-pip-text: hsla(0, 0%, 9%, 1);
    --range-pip-active: hsla(0, 0%, 67%, 1);
    --range-pip-active-text: hsla(0, 0%, 9%, 1);
    --range-pip-hover: hsla(0, 0%, 9%, 1);
    --range-pip-hover-text: hsla(0, 0%, 9%, 1);
    --range-pip-in-range: hsla(0, 0%, 67%, 1);
    --range-pip-in-range-text: hsla(0, 0%, 9%, 1);
  }
  :global(.dark) .viewer-range-slider :global(.rangeSlider) {
    font-size: 10px;
    line-height: 12px;
    --range-slider: rgba(129, 129, 129, 1);
    --range-handle-inactive: hsla(0, 0%, 96%, 1);
    --range-handle: hsla(230, 94%, 82%, 1);
    --range-handle-focus: #ffffff;
    --range-handle-border: rgba(129, 129, 129, 1);
    --range-range: rgba(129, 129, 129, 1);
    --range-range-inactive: rgba(129, 129, 129, 1);

    --range-float-inactive: hsla(0, 0%, 96%, 1);
    --range-float: hsla(230, 94%, 82%, 1);
    --range-float-text: #000000;

    --range-pip: hsla(0, 0%, 67%, 1);
    --range-pip-text: hsla(0, 0%, 9%, 1);
    --range-pip-active: hsla(0, 0%, 67%, 1);
    --range-pip-active-text: hsla(0, 0%, 9%, 1);
    --range-pip-hover: hsla(0, 0%, 9%, 1);
    --range-pip-hover-text: hsla(0, 0%, 9%, 1);
    --range-pip-in-range: hsla(0, 0%, 67%, 1);
    --range-pip-in-range-text: hsla(0, 0%, 9%, 1);
  }
  .viewer-range-slider :global(.rangeSlider:not(.vertical)) {
    min-width: 50px;
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
  .viewer-range-slider :global(.rangeSlider.vertical) {
    min-height: 50px;
    margin-top: 0;
    margin-bottom: 0;
    height: 100%;
  }
  .viewer-range-slider :global(.rangeSlider.range) {
    background: linear-gradient(
      90deg,
      #e02020 0%,
      #fa6400 16.72%,
      #f7b500 33.39%,
      #6dd400 50.05%,
      #0091ff 66.57%,
      #6236ff 83.32%,
      #b620e0 100%
    );
  }
  .viewer-range-slider :global(.rangeSlider .rangeHandle) {
    width: 16px;
    height: 16px;
  }
  .viewer-range-slider :global(.rangeSlider.vertical.range) {
    background: linear-gradient(
        0deg,
        #e02020 0%,
        #fa6400 16.72%,
        #f7b500 33.39%,
        #6dd400 50.05%,
        #0091ff 66.57%,
        #6236ff 83.32%,
        #b620e0 100%
      ),
      linear-gradient(90deg, rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.25));
  }
  .viewer-range-slider :global(.rangeSlider .rangeNub) {
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.4);
  }
</style>
